export interface TranslatorProvider {
  translate(text: string, options?: { html?: boolean; contextKey?: string }): Promise<string> | string;
}
export class LocalDictionaryProvider implements TranslatorProvider {
  private dict: Record<string, string>;
  constructor(dict: Record<string, string>) {
    this.dict = dict || {};
  }
  translate(text: string, options?: { html?: boolean; contextKey?: string }) {
    if (!text) return '';
    if (options?.contextKey && this.dict[options.contextKey]) return this.dict[options.contextKey];
    if (this.dict[text]) return this.dict[text];
    return text;
  }
}
